import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useBulkPersonalOrderSessionGiftCardStore } from './bulkPersonalOrderSessionGiftCard'
import { useBulkPersonalOrderOrdererDetailStore } from './bulkPersonalOrderOrdererDetailStore'

export const useBulkPersonalOrderSessionStore = defineStore(
  'bulkPersonalOrderSession',
  () => {
    const isAgreementBulkOrder = ref(false)

    const $reset = () => {
      const giftCardStore = useBulkPersonalOrderSessionGiftCardStore()
      const { $reset: $giftCardStoreReset } = giftCardStore
      const ordererDetailStore = useBulkPersonalOrderOrdererDetailStore()
      const { $reset: $ordererDetailStoreReset } = ordererDetailStore

      isAgreementBulkOrder.value = false
      $giftCardStoreReset()
      $ordererDetailStoreReset()
    }

    const agree = () => (isAgreementBulkOrder.value = true)

    return {
      isAgreementBulkOrder,
      $reset,
      agree
    }
  },
  {
    persist: true
  }
)
